// Chargement à la demande des outils PDF (allège l'ouverture des pages)
import { loadDict, lookup } from "./i18n";

export const generateQuotePdf = async (quote, ...a) => {
  const d = await loadDict(quote?.lang);
  const lang = quote?.lang;
  if (lang && lang !== "fr" && d && (quote.standard_equipment || []).some((x) => !lookup(d, x))) await loadDict(lang, true).catch(() => {});
  const m = await import("./pdf");
  const img = quote && !quote._vehicle_img ? await m.loadVehicleImg(quote) : null;
  const paper = quote?.paper_order && !quote._paper_imgs ? await m.loadPaperImgs(quote) : null;
  return m.generateQuotePdf({ ...quote, ...(img ? { _vehicle_img: img } : {}), ...(paper ? { _paper_imgs: paper } : {}) }, ...a);
};
export const sendQuotePdfEmail = async (...a) => (await import("./pdf")).sendQuotePdfEmail(...a);
export const generatePosterPdf = async (...a) => (await import("./poster")).generatePosterPdf(...a);
export const loadPdfjs = async () => {
  const m = await import("pdfjs-dist/build/pdf");
  m.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";
  return m;
};
